import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo/logo_dark.png';
import './footer-new.css';

function Footer() {
    const [isVisible, setIsVisible] = useState(false);
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    useEffect(() => {
        const toggleVisibility = () => {
            setIsVisible(window.pageYOffset > 500);
        };
        window.addEventListener('scroll', toggleVisibility);
        return () => window.removeEventListener('scroll', toggleVisibility);
    }, []);

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {
            const response = await fetch('https://formspree.io/f/xzdyqraq', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    subject: 'Newsletter Subscription',
                    message: `New newsletter subscription from: ${email}`
                })
            });

            if (response.ok) {
                setShowSuccess(true);
                setEmail('');
                setTimeout(() => {
                    setShowSuccess(false);
                }, 3000);
            }
        } catch (error) {
            console.error('Error subscribing:', error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const marketplace = [
        { title: 'Vouchers', path: '/dt-shop' },
        { title: 'Browse All', path: '/dt-shop' },
        { title: 'Top Deals', path: '/dt-shop' },
        { title: 'Top Brands', path: '/dt-shop' }
    ];

    const account = [
        { title: 'Login', path: '/login' },
        { title: 'Sign Up', path: '/signup' },
        { title: 'My Profile', path: '/dashboard' },
        { title: 'My Vouchers', path: '/dashboard' }
    ];

    const resources = [
        { title: 'Blogs', path: '/blog' },
        { title: 'Help Center', path: '/help-center' },
        { title: 'FAQs', path: '/faqs' },
        { title: 'Support', path: '/contact' }
    ];

    const company = [
        { title: 'About Us', path: '/about-us' },
        { title: 'Policies', path: '/Policies' },
        { title: 'Redeem', path: '/login' }
    ];

    const socials = [
        { icon: 'fab fa-facebook-f', path: 'https://www.facebook.com/profile.php?id=61570780382050' },
        { icon: 'fab fa-instagram', path: 'https://www.instagram.com/dt.wallet/' },
        { icon: 'fab fa-youtube', path: 'https://youtube.com/@dtwallet' },
        { icon: 'fab fa-telegram-plane', path: 'https://t.me/dtwallet' },
        { icon: 'fab fa-pinterest-p', path: 'https://pin.it/EJ9nl0XLo' },
        { icon: 'fab fa-linkedin-in', path: 'https://www.linkedin.com/company/114604067/' }
    ];

    return (
        <footer className="dt-footer">
            <div className="dt-footer-container">
                <div className="dt-footer-grid">
                    {/* Brand Column */}
                    <div className="dt-footer-brand">
                        <Link to="/">
                            <img src={logo} alt="D.T Wallet" className="dt-footer-logo" />
                        </Link>
                        <p className="dt-footer-desc">
                            D.T Wallet is your secure voucher marketplace. Buy, store, and
                            redeem vouchers from top brands with transparent pricing and
                            real, verifiable savings.
                        </p>
                        <ul className="dt-footer-social">
                            {socials.map((s, i) => (
                                <li key={i}>
                                    <Link to={s.path} aria-label="social">
                                        <i className={s.icon}></i>
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Links Columns */}
                    <div className="dt-footer-links">
                        <div className="dt-footer-col">
                            <h6>Marketplace</h6>
                            <ul>
                                {marketplace.map((l, i) => (
                                    <li key={i}><Link to={l.path}>{l.title}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className="dt-footer-col">
                            <h6>Account</h6>
                            <ul>
                                {account.map((l, i) => (
                                    <li key={i}><Link to={l.path}>{l.title}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className="dt-footer-col">
                            <h6>Resources</h6>
                            <ul>
                                {resources.map((l, i) => (
                                    <li key={i}><Link to={l.path}>{l.title}</Link></li>
                                ))}
                            </ul>
                        </div>
                        <div className="dt-footer-col">
                            <h6>Company</h6>
                            <ul>
                                {company.map((l, i) => (
                                    <li key={i}><Link to={l.path}>{l.title}</Link></li>
                                ))}
                            </ul>
                        </div>
                    </div>

                    {/* Newsletter */}
                    <div className="dt-footer-news">
                        <h6>Stay Updated</h6>
                        <p>Subscribe to get the latest deals and voucher updates in your inbox.</p>
                        <form className="dt-footer-form" onSubmit={handleNewsletterSubmit}>
                            <input 
                                type="email" 
                                placeholder="Enter your email" 
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled={isSubmitting}
                                required 
                            />
                            <button 
                                type="submit" 
                                aria-label="subscribe"
                                disabled={isSubmitting}
                                style={{
                                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                    opacity: isSubmitting ? 0.6 : 1
                                }}
                            >
                                <i className={isSubmitting ? "fas fa-spinner fa-spin" : "fas fa-paper-plane"}></i>
                            </button>
                        </form>
                        {showSuccess && (
                            <p style={{
                                marginTop: '10px',
                                color: '#FFC107',
                                fontSize: '14px',
                                fontWeight: '600'
                            }}>
                                ✓ Successfully subscribed!
                            </p>
                        )}
                    </div>
                </div>

                {/* Bottom Bar */}
                <div className="dt-footer-bottom">
                    <p className="dt-footer-copyright">
                        © {new Date().getFullYear()} D.T Wallet — Voucher Vault & Rewards Platform. All rights reserved.
                    </p>
                    <ul className="dt-footer-legal">
                        <li><Link to="/Policies">Privacy Policy</Link></li>
                        <li><Link to="/Policies">Terms of Service</Link></li>
                        <li><Link to="/Policies">Cookie Policy</Link></li>
                    </ul>
                </div>
            </div>

            {isVisible && (
                <button onClick={scrollToTop} className="dt-scroll-top" aria-label="Scroll to top">
                    ↑
                </button>
            )}
        </footer>
    );
}

export default Footer;
